import FancyBoxSvg230x765 from './FancyBoxSvg230x765';

export default FancyBoxSvg230x765;
export { FancyBoxSvg230x765 };
